import React, { ReactNode, useState } from "react";
import { FormSelect } from "react-bootstrap";

interface Props extends React.ComponentProps<typeof FormSelect> {
  children: ReactNode[];
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
}

const CustomFormSelect: React.FC<Props> = ({
  children,
  onChange,
  className,
  ...otherProps
}) => {
  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <FormSelect
      value={selectedValue}
      {...otherProps}
      bsPrefix="custom-select"
      onChange={handleChange}
      className={className}
    >
      {children}
    </FormSelect>
  );
};

export default CustomFormSelect;
